import React, { ReactNode } from 'react'
import { Button, UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {IconDefinition, SizeProp} from '@fortawesome/fontawesome-svg-core'
import {
	QuestionCircleSoildIcon
} from '@csrc/assets/icons'

interface HelperIconProps {
  name?: string;
  text?: string | ReactNode;
  size?: SizeProp | undefined;
  color?: string;
  headerText?: string;
  className?: string;
  children?: ReactNode;
  icon?: IconDefinition | null;
  triggerTooltipOnClick?: boolean;
}

const HelperIcon: React.FC<HelperIconProps> = ({
  name = '',
  text,
  size,
  color,
  headerText,
  className = '',
  children,
  icon = null,
  triggerTooltipOnClick = false
}) => {
	return (
		<>
			{/*<i className='ml-50'  id={`pw-tooltip-${name}`}>*/}
			{/*	<AlertCircle size={size ?? 12} className={'text-primary'} />*/}
			{/*</i>*/}
			{/*<UncontrolledTooltip placement='top' target={`pw-tooltip-${name}`}>*/}
			{/*	{text}*/}
			{/*</UncontrolledTooltip>*/}
			<Button className={`helper-icon p-0 ${className}`} color={color ?? 'primary'} outline id={`popover-${(`${name}`).replaceAll('.', '-')}`} onClick={(e: React.MouseEvent) => e.stopPropagation()} tabIndex={0}>
				{children ?? <FontAwesomeIcon icon={icon || QuestionCircleSoildIcon} size={size ?? 'xs'} className={`text-${color ?? 'primary'}`} color={'#000'} />}
			</Button>
			{text && <UncontrolledPopover trigger={triggerTooltipOnClick ? 'click' : 'focus'} placement='top' target={`popover-${(`${name}`).replaceAll('.', '-')}`}>
				{headerText && <PopoverHeader>{headerText}</PopoverHeader>}
				<PopoverBody>
					{text}
				</PopoverBody>
			</UncontrolledPopover>}
		</>
	)
}

export default HelperIcon
